<template>
  <v-row no-gutters>
    <v-col 
      :class="color"
      cols="12" 
      class="text-no-wrap text-center rounded py-0 px-2">
        <span class="feed-text font-weight-bold">
          {{ channel.channelNumDisplay }}
          <template v-if="channel.channelNumDisplay != channel.channelCallsignDisplay"> - 
            {{ channel.channelCallsignDisplay }} 
          </template>
        </span>
        <span 
          :class="lit ? 'white-channel' : 'black-channel'"
          class="feed-chip mx-1" 
          v-if="channel.feed">
          {{ channel.feed }} 
        </span>
    </v-col>
    
  </v-row>
</template>

<script>
export default {
  name: "Channel",
  props: {
    channel: Object,
    index: Number,
    lit: Boolean
  },
  computed: {
    color() {
      if (this.channel.nonDTV) {
        //Yes, not a DTV Channel
        return this.lit ? 'warning' : 'warning--text';
      } else {
        //No, not a DTV Channel
        return this.lit ? 'blue white--text' : 'blue--text';
      }
    }
  }
};
</script>

<style scoped>
.feed-text {
  font-size: 11px;
}
.feed-chip {
  padding-top: 2px;
  padding-left: 1px;
  padding-right: 1px;
  font-weight: bolder;
  font-size: 8px;
  border-radius: 4px;
  border-style: solid;
  border-width: 2px;
}
.white-channel {
  border-color: white;
}
.black-channel {
  border-color:black;
}
</style>